export default __webpack_public_path__ + "static/media/voicenote-screenshot-02.64104e06.png";